/**
 * Dashboard Store
 *
 * @since 2018-05-08
 * @author ms1124.kim
 *
 */
// 공통 모듈 Import
import Moment from 'moment'
import JSONBigInt from 'json-bigint'

const widgetApiPath = '/api/lr/dashboard'
const basicDateFormat = 'YYYY-MM-DD HH:mm:ss'
const url = {
  // 대시보드 조회/추가
  dashboard: '/api/da/dashboard',
  // 대시보드 정보 수정/삭제
  dashboardConfig: '/api/da/dashboard/config',
  // 대시보드 위젯/설정 적용
  dashboardConfigPopup: '/api/da/dashboard/config/popup',
  // 대시보드 데이터 조회 (Prism)
  dashboardData: '/api/da/dashboard/data',
  // 기본 대시보드 수정
  dashboardDefault: '/api/da/dashboard/default',
  // 위젯 리스트
  dashboardWidget: '/api/da/dashboard/widget'
}

const DASHBD_TYPE = 1

/* Store > state
  dashboards: 서버에 저장된 대시보드 목록. (이름, 아이디 - 상단 q-select 맵핑)
  refreshTime: 현재 대시보드에 설정되어있는 갱신 주기
  dashboardInfo: 현재 대시보드의 상세 정보.
  selectedDashboard: 현재 대시보드의 ID.
  defaultFilterDevice: 상단 장비 필터 리스트.
*/
export const state = () => ({
  widgetList: [],
  dashboards: [],
  refreshTime: 0,
  dashboardInfo: {},
  selectedDashboard: 0,
  defaultWidgetList: [],

  // TAMS
  // filterDateObj: {},
  // filterDateText: '',
  defaultFilterDevice: void 0,
  filterDate: 0,
  filterDevice: void 0,
  filterDeviceText: '',
  filterDeviceNot: false,
  isChanged: false
})

export const mutations = {
  /*
    이름 : addDashboard
    설명 : 스토어의 상태값에 대시보드를 반영한다. (TAMS 미사용)
  */
  // addDashboard (state, newDashboard) {
  //   // 대시보드 목록에 새로운 대시보드 추가.
  //   state.dashboards.push({
  //     name: newDashboard.name,
  //     dashboard_id: newDashboard.dashboard_id
  //   })
  // },
  /*
    이름 : modDashboard
    설명 : 스토어의 상태값에서 대상 대시보드를 찾아 정보를 변경한다. (TAMS 수정됨)
  */
  modDashboard (state, payload) {
    const
      dashboardData = _.cloneDeep(payload),
      dashbdOptions = dashboardData.dashbd_opt_set

    state.dashboardInfo.dashbd_uname = dashboardData.dashbd_uname
    state.dashboardInfo.dashbd_desc = dashboardData.dashbd_desc

    state.filterDevice = _.isEmpty(state.defaultFilterDevice) ? (dashbdOptions.hasOwnProperty('filter_device') ? dashbdOptions.filter_device : []) : state.defaultFilterDevice
  },
  /*
    이름 : delDashboard
    설명 : 스토어의 상태값에서 대상 대시보드를 찾아 제거한다. (TAMS 미사용)
  */
  // delDashboard (state, dashboardId) {
  //   // 스토어 목록에서 제거
  //   state.dashboards = state.dashboards.filter(dashboard => dashboard.dashboard_id !== dashboardId)
  // },
  /*
    이름 : setDashboards
    설명 : 대시보드 추가, 수정, 삭제 시 대시보드 정보를 스토어에 반영한다.
  */
  setDashboards (state, resDashboards) {
    state.dashboards = resDashboards
  },
  /*
    이름 : setDashboardTimer
    설명 : 대시보드 컴포넌트의 전역 타이머를 변경한다.
  */
  setDashboardTimer (state, timerValue) {
    state.refreshTime = timerValue
  },
  /*
    이름 : setWidgets
    설명 : 현재 대시보드의 위젯 리스트를 업데이트한다. (TAMS 수정됨)
  */
  setWidgets (state, {widget}) {
    // 대시보드 위젯 추가
    state.dashboardInfo.dashbd_widget_set = widget
  },
  /*
    이름 : setSelectDashboard
    설명 : 스토어에 대시보드 갱신주기, 현재 대시보드 데이터, 선택되어있는 대시보드 정보를 갱신한다. (TAMS 수정됨)
  */
  setSelectDashboard (state, dashboardData) {
    state.dashboardInfo = _.cloneDeep(dashboardData)
    state.selectedDashboard = dashboardData.dashbd_id

    const dashbdOptions = dashboardData.dashbd_opt_set

    state.refreshTime = dashbdOptions.hasOwnProperty('refresh_tm') ? dashbdOptions.refresh_tm : 0
    state.filterDate = dashbdOptions.hasOwnProperty('filter_date') ? dashbdOptions.filter_date : 360 // 6h
    // state.filterDevice = dashboardData.hasOwnProperty('device_id_list') ? JSON.parse(dashboardData.device_id_list) : []
    state.filterDevice = _.isEmpty(state.defaultFilterDevice) ? (dashbdOptions.hasOwnProperty('filter_device') ? dashbdOptions.filter_device : []) : state.defaultFilterDevice
    state.filterDeviceNot = false // 초기화
  },
  /*
    이름 : addWidget
    설명 : 현재 대시보드의 위젯목록에 새로운 위젯을 추가한다. (TAMS 수정됨)
  */
  addWidget (state, widgetData) {
    // 위젯 순위 설정
    widgetData.widget.s = state.dashboardInfo.dashbd_widget_set.length
    // 현재 대시보드의 위젯에 새로운 위젯 추가
    state.dashboardInfo.dashbd_widget_set.push(widgetData.widget)
    // 위젯 Callback 실행
    widgetData.makeInstance(widgetData.widget.i)
  },
  /*
    이름 : delWidget
    설명 : 현재 대시보드의 Widget에서 삭제 대상 ID를 가지는 위젯을 제외한 나머지를 저장한다. (TAMS 수정됨)
  */
  delWidget (state, widgetId) {
    state.dashboardInfo.dashbd_widget_set = state.dashboardInfo.dashbd_widget_set.filter(widget => widget.i !== widgetId)
  },
  /*
    이름 : initStore
    설명 : 스토어를 초기상태로 변경한다. (TAMS 수정됨)
  */
  initStore (state) {
    state.widgetList = []
    state.dashboards = []
    state.dashboardInfo = {}
    state.selectedDashboard = 0
    state.defaultWidgetList = []

    // TAMS
    state.refreshTime = 0
    state.filterDate = 360 // 6h
    state.filterDevice = void 0
    state.filterDeviceText = ''
    state.filterDeviceNot = false
    state.defaultFilterDevice = void 0
    // state.vlanId = -1
    state.isChanged = false
  },
  /**
   * 이름: resortWidgetNumber
   * 설명: 대시보드에 등록된 순서대로 넘버링을 재정렬한다.
   */
  resortWidgetNumber (state, widgetContents) {
    // 동일 위젯 컨텐츠 검색
    const sameWidgets = state.dashboardInfo.dashbd_widget_set.filter(({contents}) => contents === widgetContents) || []

    // 동일 위젯 컨텐츠에 대해 넘버링 재정렬
    for (let i = 0, max = sameWidgets.length; i < max; i++) {
      sameWidgets[i].n = i
    }
  },
  /*
    이름: setDashboardWidgetList
    설명: 대시보드 위젯 목록을 저장한다.
  */
  setDashboardWidgetList (state, widgetList) {
    state.widgetList = widgetList
  },
  /*
    이름: setDefaultDashboardWidgets
    설명: Default 대시보드 위젯 목록을 불러온다. (TAMS 미사용)
  */
  // setDefaultDashboardWidgets (state, widgetList) {
  //   state.defaultWidgetList = widgetList
  // },

  // TAMS
  // setFilterDateObj (state, filterDateObj) {
  //   state.filterDateObj = filterDateObj
  // },
  // setFilterDateText (state, payload) {
  //   state.filterDateText = payload
  // },
  setFilterDate (state, payload) {
    state.filterDate = payload
  },
  setFilterDevice (state, payload) {
    state.filterDevice = payload
    state.defaultFilterDevice = _.cloneDeep(payload)
  },
  setFilterDeviceText (state, payload) {
    state.filterDeviceText = payload
  },
  setFilterDeviceNot (state, payload) {
    state.filterDeviceNot = payload
  },
  // 변경 여부 flag 설정
  setIsChanged (state, changed = false) {
    state.isChanged = changed
  }
}

export const actions = {
  /*
    이름 : getDashboardList
    설명 : 서버에 저장된 대시보드 목록에서 이름과 아이디만 추출하여 스토어의 대시보드 목록에 저장한다. (TAMS 수정됨)
  */
  async getDashboardList ({state, commit}) {
    let res = {
      code: 'ok',
      result: {}
    }
    try {
      // 0. 저장된 대시보드 정보 가져오기 (REST API 부분)
      res = await this.$axios.$get(`${url.dashboard}/profile/${DASHBD_TYPE}`, {
        loading: false,
        successAlert: false,
        ignoreHaPrefix: true
      })

      if (res.code === 'ok') {
        // 1. 대시보드 목록에서 Label / ID 넣기
        const dashboardList = []
        for (const dashboard of res.result) {
          dashboardList.push({
            dashbd_uname: dashboard.dashbd_uname,
            dashbd_id: dashboard.dashbd_id
          })
        }
        // 아이디 오름차순 정렬
        dashboardList.sort((a, b) => a.dashbd_id - b.dashbd_id)

        // 2. 스토어에 데이터 추가
        commit('setDashboards', dashboardList)
      }
    } catch (e) {
      res.code = 'nok'
      res.result.msg = e.message
    }
    return res
  },
  /*
    이름 : getDashboardData
    설명 : 대시보드의 정보를 서버에서 리턴받는다. 파라미터로 ID를 전달하면 해당하는 대시보드의 정보만 가져온다. (TAMS 미사용)
  */
  // async getDashboardData ({state, commit, rootState}, {dashboardId}) {
  //   // 0. 저장된 대시보드 정보 가져오기 (REST API 부분)
  //   const {code, result} = await this.$axios.$get(`${dashApiPath}/${rootState.common.common.uiData.user.adm_id || 1}/dashboards/${dashboardId}`, {
  //     loading: false,
  //     successAlert: false
  //   })
  //
  //   if (code === 'ok') {
  //     return result
  //   }
  // },
  /*
    이름 : setDashboardData
    설명 : 현재 선택 되어있는 대시보드의 이름, ID, 설명, 타이머, 위젯 리스트를 저장한다. (TAMS 수정됨)
  */
  async setDashboardData ({state, commit, dispatch}, {params, action}) {
    // 0. 대시보드 ID
    const dashbdId = state.dashboardInfo.dashbd_id
    const apiPath = (action === 'popup') ? url.dashboardConfigPopup : url.dashboardConfig

    // 2. REST API 호출 부분
    const {code} = await this.$axios.$put(`${apiPath}/${dashbdId}`, params, {
      successAlert: false,
      ignoreHaPrefix: true
    })
    if (code !== 'ok' || action !== 'popup') return
    // 3. 호출이 성공이면 스토어에 대시보드 정보 반영
    // TAMS 설계 변경으로 인한 사이드 이펙트 발생. (정보 갱신 시, 대시보드 id 값으로 위젯 i값이 정렬되어 있지 않으면 위젯 겹침현상)
    // 갱신은 하지 않고 현재 값으로 유지되도록 변경 (선택 변경시만 갱신)
    // action popup 시에는 정보 갱신
    await dispatch('getDashboardList').then(res => {
      if (res.code === 'ok') {
        const dashboardData = res.result.find(dashboard => dashboard.dashbd_id === dashbdId)
        // 3-1. 스토어의 선택된 대시보드 정보를 갱신
        commit('modDashboard', dashboardData)
      } else {
        this.$log('[Dashboard Store Error (setDashboardData)', res.result.msg)
      }
    })
  },
  /*
    이름 : changeDashboard
    설명 : 대시보드 선택이 변경되면 서버에서 대시보드 정보를 다시 불러오고, 스토어에 반영한다. (TAMS 수정됨)
  */
  async changeDashboard ({commit, rootState, state, dispatch}, {dashboardId, isNewWindow, apply}) {
    // 0. REST API 호출
    // const {code, result} = await this.$axios.$get(`${dashApiPath}/${rootState.common.common.uiData.user.adm_id || 1}/dashboards/${dashboardId}`, {
    //   loading: false,
    //   successAlert: false
    // })

    /* ============================================= */
    // 방안 1. (대신, 체인지 될때마다 서버 통신)
    // 최초 로딩 시에는 i값에 대해서 갱신이 되나, 차후 로딩 시 안되는 단점이 있음
    // const {code, result} = await this.$axios.$get(url.dashboard, {
    //   loading: false,
    //   successAlert: false
    // })
    // // 1. 조회된 대시보드 정보 확인
    // if (code === 'ok') {
    //   const dashboardData = result.find(dashboard => dashboard.dashbd_id === dashboardId)
    //
    //   dashboardData.dashbd_widget_set = dashboardData.dashbd_widget_set || []
    //
    //   commit('setSelectDashboard', dashboardData)
    // }
    /* ============================================= */

    // Mod 될 때 는 데이터를 갱신하지 않으나 선택이 변경될때 데이터를 갱신하여 gridstack 겹침현상 제거 (2019-01-31)
    /* ============================================= */
    // 방안 2. (단, async-await 필수, 데이터는 정상 출력되나 state값이 commit 되면서 타이밍이 어긋나는 것으로 추측됨 (대신, 불필요 API 호출횟수 감소))
    // const dashboardData = await state.dashboardDatas.find(dashboard => {
    //   return dashboard.dashbd_id === dashboardId
    // })
    //
    // dashboardData.dashbd_widget_set = dashboardData.dashbd_widget_set || []
    //
    // // 1. 조회된 대시보드 정보 확인
    // if (typeof dashboardData !== 'undefined') {
    //   commit('setSelectDashboard', dashboardData)
    // }
    /* ============================================= */

    /* ============================================= */
    // 방안 3. NGF 설계 방식 TAMS 커스터마이징
    // 선택된 대시보드로 기본 대시보드 설정 변경

    const {code, result} = await this.$axios.$get(`${url.dashboard}/profile/${DASHBD_TYPE}`, {
      loading: false,
      successAlert: false,
      ignoreHaPrefix: true
    })
    if (code !== 'ok') return
    // 새 창 열기가 아닐 때 만 스위칭 default로 변경함.
    // TAMS, 적용 필요 시 (최초 화면 호출 시 제외)
    if (!isNewWindow && apply) {
      await this.$axios.$put(`${url.dashboardDefault}/${dashboardId}`, void 0, {
        loading: false,
        successAlert: false,
        ignoreHaPrefix: true
      })
    }

    const dashboardData = result.find(dashboard => dashboard.dashbd_id === dashboardId)
    // TAMS (widget.i 값 재설정, 신규 계정 default profile 설정됨에 따른 상이 dashbd_id 값 상이 방지)
    for (const widget of dashboardData.dashbd_widget_set) {
      try {
        const splitDashbd = widget.i.split('_')
        const splitDashbdId = parseInt(splitDashbd)
        // 최초 반복 시, split 된 접두 dashboard_id 가 일치하면, 데이터 보정하지 않고 중지 (이미 맞음으로 판단)
        if (splitDashbdId === dashboardId) break
        widget.i = `${dashboardId}_${_.join(_.drop(splitDashbd), '_')}`
      } catch (e) {}
    }

    // 3-1. 스토어의 선택된 대시보드 정보를 갱신
    commit('setSelectDashboard', dashboardData)
    /* ============================================= */
  },
  /*
    이름 : setDefaultDashboard
    설명 : 대상 대시보드를 Default로 설정한다. (TAMS 미사용)
  */
  // async setDefaultDashboard ({rootState}, {dashboardId}) {
  //   // 0. REST API 호출 부분
  //   const {code, result} = await this.$axios.$put(`${dashApiPath}/${rootState.common.common.uiData.user.adm_id}/dashboards/${dashboardId}/default`, null, {
  //     loading: false,
  //     successAlert: false
  //   })
  //
  //   if (code === 'ok') {
  //     return result
  //   }
  // },
  /*
    이름 : addNewDashboard
    설명 : 새로운 대시보드를 추가한다. (TAMS 수정됨)
  */
  async addNewDashboard ({commit, dispatch}, {dashboard}) {
    let res = {
      code: 'ok',
      result: {}
    }
    try {
      // 0. REST API 호출 부분
      res = await this.$axios.$post(`${url.dashboard}/profile/${DASHBD_TYPE}`, dashboard, {
        loading: false,
        ignoreHaPrefix: true
      })

      if (res.code === 'ok') {
        res = await dispatch('getDashboardList')
      }
    } catch (e) {
      res.code = 'nok'
      res.result.msg = e.message
    }
    return res
  },
  /*
    이름 : delCurrentDashboard
    설명 : 현재 대시보드를 제거한다. (TAMS 수정됨)
  */
  async delCurrentDashboard ({state, commit, rootState, dispatch}, {dashboardId}) {
    // 0. REST API 호출 부분
    const {code} = await this.$axios.$delete(`${url.dashboardConfig}/${dashboardId}`, void 0, {
      loading: false,
      successAlert: false,
      ignoreHaPrefix: true
    })

    // 1. 삭제 확인
    if (code === 'ok') {
      // 1-1. 대시보드 스토어 반영
      await dispatch('getDashboardList')
    }
  },
  /*
    이름 : applyDashboard
    설명 : 현재 DB의 트랜젝션을 Commit 한다. (미사용)
  */
  async applyDashboard () {
    // // 0. REST API 호출 부분
    // await this.$axios.$put(`${dashApiPath}/command/dashboards/apply`, null, {
    //   loading: false,
    //   successAlert: false
    // })
  },
  /*
    이름 : cancelDashboard
    설명 : 현재 DB의 트랜젝션을 모두 ROLLBACK 한다.
  */
  async cancelDashboard ({dispatch}) {
    // 0. REST API 호출 부분
    await this.$axios.$put(`${url.dashboard}/cancel`, void 0, {
      loading: false,
      successAlert: false,
      ignoreHaPrefix: true
    })
    await dispatch('setIsChanged', false)
  },
  /*
    이름 : getWidgetData
    설명 : 위젯별 컨텐츠 데이터를 서비스에 요청하고 데이터를 리턴한다. (TAMS 수정됨)
           - IP 버전 : All(0), IPv4(1), IPv6(2)
  */
  async getWidgetData ({state, commit}, {vlanId = void 0, widgetType, timeRange = 1, topN = 10, sTime = null, eTime = null, filterDeviceList = [], ipType = 0, machId = []}) {
    const res = { code: 'ok', eTime: '', result: [] }
    let endTime = null, startTime = null
    // 위젯에서 sTime과 eTime을 계산하지 않는 경우 (TopN 데이터, 통계 데이터를 기준으로 하는 추이 데이터)
    if (sTime === null || eTime === null) {
      let devBaseTime = null
      // 장비시간 가져오기
      const deviceTime = this.getters['common/common/getDeviceTime']

      // 장비 시간에서 3분을 뺀 시간을 기준으로 잡는다. (통계 데이터 쌓는 시간 기준)
      devBaseTime = Moment(deviceTime).subtract(3, 'minutes')

      // timeRange가 1이상 일 경우 1시간 기준 데이터 (초단위 00 ~ 59 초기화)
      const calcBaseTime = _.cloneDeep(devBaseTime)
      const filterTimeRange = state.filterDate

      // startTime = devBaseTime - timeRange시간 + 초 00으로 초기화
      startTime = calcBaseTime.subtract(filterTimeRange, 'minutes').startOf('minutes').format(basicDateFormat)

      // eTime = calcBaseTime - 1초
      endTime = Moment(devBaseTime).startOf('minutes').subtract(1, 'seconds').format(basicDateFormat)
    } else {
      // 위젯에서 계산해서 들어오는 경우 - 실시간 위젯
      endTime = eTime
      startTime = sTime
    }

    // 마지막 시간 저장
    res.eTime = endTime

    try {
      // 시스템 자원 현황 예외처리( filterDeviceList > 0 ), 이외 위젯은 상단 장비 device_name 에서 위젯 별 device_id 리스트로 변경?.
      // << filterDevice 적용 순서 >>
      //  1. filterDeviceList (시스템 지원 현황 장비 필터)
      //  2. machId (위젯별 장비 필터)
      //  3. filterDevice (전역 장비 필터)
      //  4. 장비 이름('device_uname') 값을 추출
      const
        // deviceData = this.getters['common/filter/getTreeData'],
        machIds = !_.isEmpty(filterDeviceList) ? filterDeviceList // (시스템 지원 현황 장비 필터)
          : _.map(
            !_.isEmpty(machId) ? machId // (위젯별 장비 필터)
              : !_.isEmpty(state.filterDevice) ? state.filterDevice // (전역 장비 필터)
                : [], 'device_uname') // 장비 이름('device_uname') 값을 추출.

      const params = {
        type: widgetType,
        stime: startTime,
        etime: endTime,
        top: topN,
        vlan_id: void 0,
        filters: [{ key: 'mach_id', value: machIds, is_not: state.filterDeviceNot }]
      }
      if (!_.isNil(vlanId)) { // --- VLAN 트래픽 추이 에만 해당
        params.vlan_id = vlanId
        delete params.top
      }

      if (ipType) { // --- VLAN 트래픽 추이 에만 해당, IP Type 선택 필터 추가 화면(종합, 방화벽, 보안)
        params.filters.push({ key: 'ip_type', value: ipType, is_not: false })
      }

      const {code, result} = await this.$axios.$post(widgetApiPath, params, {
        loading: false,
        successAlert: false,
        ignoreHaPrefix: true,
        transformResponse: [ (data) => { return JSONBigInt.parse(data) } ]
      })

      if (code.toUpperCase() === 'OK') {
        res.result = result || { result: [], unit_time: '' }
      }
    } catch (e) {
      res.code = 'nok'
      res.reason = e
    }
    return res
  },

  // TAMS 현재 미사용 (overall 토폴로지만 사용)
  async getPrismWidgetData ({state}, {widgetType}) {
    // Axios 호출
    const {code, result} = await this.$axios.$get(`${url.dashboardData}/${widgetType}`, {
      loading: false,
      successAlert: false,
      ignoreHaPrefix: true
    })

    // 호출된 데이터 확인
    if (code.toUpperCase() === 'OK') {
      return result
    }
  },
  /*
    이름: getDashboardWidgetList
    설명: 대시보드의 위젯 목록을 서버로부터 불러온다. (TAMS 수정됨)
  */
  async getDashboardWidgetList ({state, commit}) {
    // 이미 불러온 대시보드 위젯 리스트가 있다면 리턴
    if (state.widgetList.length > 0) {
      return
    }

    // 분석 > 패널리스트가 없으면 조회
    const {code, result} = await this.$axios.$get(url.dashboardWidget, {
      loading: false,
      successAlert: false,
      ignoreHaPrefix: true
    })

    if (code === 'ok') {
      // 위젯 메뉴 초기화 (서비스 업데이트 시 반영)
      commit('setDashboardWidgetList', result.widgetMenu)

      // TAMS 제외
      // 대시보드 Default 위젯목록
      // commit('setDefaultDashboardWidgets', result.defaultLayout)

      return result
    }
  },
  // 데이터 변경 여부 (TAMS)
  setIsChanged ({state, commit}, changed) {
    commit('setIsChanged', changed)
  }
}
export const getters = {
  /*
    이름 : dashboardList
    설명 : 저장되어있는 대시보드의 목록을 Select 폼에 맞게 변경하여 리턴한다. (TAMS 수정됨)
  */
  dashboardList (state) {
    return state.dashboards.map(function (dashboard) {
      return {
        label: dashboard.dashbd_uname,
        value: dashboard.dashbd_id,
        authLevel: 'force'
      }
    })
  },
  // TAMS
  isChanged (state) {
    return state.isChanged
  }
}
export const strict = false
